import Link from "@mui/material/Link";
import Grid from "@mui/material/Grid";
import {Box, Typography} from "@mui/material";
import {OriginalCalendarURI} from "./Button/OriginalCalendarButton.jsx";
import {OutOfTownURI} from "./Button/OutOfTownButton.jsx";
import {InTownURI} from "./Button/InTownButton.jsx";
import {DailyCalendarURI} from "./Button/DailyCalendarButton.jsx";

export const SiteMap = () => <Box py={2}>
    <Grid container>
        <Grid item xs={12}>
            <Typography variant="h6">Site Map</Typography>
        </Grid>
        <Grid item xs={12} md={3}>
              <div><Link href={"/where-to-dance"} underline={"hover"} variant={"overline"}>Where to Dance</Link></div>
              <div><Link href={OriginalCalendarURI}>Pro (Original) Calendar</Link></div>
              <div><Link href={DailyCalendarURI}>Calendar</Link></div>
              <div><Link href={InTownURI}>Venues In & Around Austin</Link></div>
              <div><Link href={OutOfTownURI}>Venues Far Away</Link></div>
              <div><Link href={"/holiday-2-steppin"}>Holiday Guide</Link></div>
        </Grid>
        <Grid item xs={12} md={3}>
            <Typography variant={"overline"}>Learn to Dance</Typography>
            <div><Link href={"/twostep-lessons"}>Two Step Lessons</Link></div>
            <div><Link href={"/quick-start-austin-2-step-guide"}>Austin 2-Step Guide</Link></div>
            <div><Link href={"/shopping"}>Shopping</Link></div>
            <div><Link href={"/boot-guide"}>Boot Guide</Link></div>
        </Grid>
        <Grid item xs={12} md={3}>
            <div><Link href={"/community"} underline={"hover"} variant={"overline"}>Community</Link></div>
            <div><Link href={"/community/playlists"}>Playlists</Link></div>
            <div><Link href={"/community/artists"}>Artists</Link></div>
            <div><Link href={"/community/profiles"}>Profiles</Link></div>
        </Grid>
        <Grid item xs={12} md={3}>
            <Typography variant={"overline"}>About this Site</Typography>
            <div><Link href={"/about"}>About</Link></div>
            <div><Link href={"/contact"}>Contact</Link></div>
            <div><Link href={"/privacy"}>Privacy Policy</Link></div>
            <div><Link href={"/announcements"}>Announcements</Link></div>
        </Grid>
    </Grid>
</Box>